<template>
    <div class="row">
        <div class="col-12">
            <div class="list-group-item align-items-center">
                <div class="row">
                    <div class="col-10"> 
                        <div class="form-inline">
                            <template v-for="(options,x) in getOptions">
                                <SelectInput
                                    :key="x"
                                    v-if="displayInput(x) && getOptions[0].length > 0"
                                    :disabled="displayInput(x+2)"
                                    v-model="node_query[x]"
                                    :nullable="true"
                                    :nullLabel="x == 0 ? $t('curriculum') : $t('child-n',{n : x})"
                                    :options="options"
                                    :label="x == 0 ? $t('curriculum') : $t('child-n',{n : x})"
                                    :srOnly="true"
                                    class="ml-2 align-items-center"
                                    @input="$emit('filtered-nodes', filteredNodes)"
                                />
                            </template>
                            <TextInput
                                v-if="(getOptions.length > 1 || outmost_query) && !graphView"
                                v-model="outmost_query"
                                :nullable="true"
                                :nullLabel="$t('search')"
                                :label="$t('search')"
                                :srOnly="true"
                                class="ml-2"
                                @input="$emit('filtered-nodes', filteredNodes)"
                            />
                            
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="float-right">
                            <button 
                                v-if="graphView"
                                :disabled="node_query.filter(x => x !== null).length == 0" 
                                class="btn btn-primary ml-2 text-right" 
                                @click="$router.push(`/curriculum-mapping/node/${filteredNodes[0].id}/graph`)">
                                {{ $t('go') }} <b-icon icon="arrow-right" class="ml-2" />
                            </button>
                            <button 
                                v-if="node_query.length>0"
                                :disabled="node_query.filter(x => x !== null).length == 0" 
                                class="btn btn-secondary ml-2 text-right" 
                                @click="node_query = [null]; hydrateNodeQuery(); $emit('filtered-nodes', filteredNodes)">
                                {{ $t('clear') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
export default {
    components: {

    },
    props: {
        nodes: Array,
        graphView: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        maxPath(newValue) {
            this.resetNodeQuery(newValue);
        },
        filteredNodes(newValue) {
            this.hydrateNodeQuery(newValue);
        },
    },
    data() {
        return {
            node_query:[null],
            outmost_query: null,
        };
    },
    mounted(){
    },
    methods: {
        displayInput(index){
            if (index == 0) {// Always render the first SelectInput
                return true;
            } else {// Render if the previous v-model is non-empty
                return !!this.node_query[index - 1] && this.displayInput(index - 1);
            }
        },
        hydrateNodeQuery(){
            const index = this.node_query.findIndex(str => !str);
            if (index !== -1) {
                for (let i = index + 1; i < this.node_query.length; i++) {
                    this.node_query[i] = null;
                }
            }
        },
        resetNodeQuery(){
            for (let i = 0; i < this.maxPath; i++) {
                this.node_query.push(null);
            }
        },
    },
    computed: {
        maxPath() {
            let max = 0;
            for (let obj of this.filteredNodes) {
                let offset = 1;
                if(this.graphView) offset = 0
                const vertex = obj.path.split('>').length - offset;
                if (vertex > max) max = vertex;
            }
            return max;
        },
        getOptions() {
            let child ={}
            for (let i=0; i<=this.maxPath; i++){
                child[i]=new Set();
            }

            for (let obj of this.filteredNodes) {
                let string = obj.path.split('>');
                if(string.length>1){
                    let offset = 1;
                    if(this.graphView) offset = 0;

                    for(let i=0; i<=string.length-offset; i++){
                        if(string[i]) child[i].add(string[i]);
                    }
                } else {
                    child[0].add(string[0])
                }

            }

            let result =[];
            for(let i=0; i<=this.maxPath; i++) {
                result.push(Array.from(child[i]));
            }

            // If an entry is empty, then it stops at the previous member
            if(this.maxPath>1){
                const index = result.findIndex(str => !str);
                result = result.slice(0, index);
            }

            // Check if it is totally empty
            if(
                this.maxPath > 1 
                && 
                result.every(subArr => Array.isArray(subArr) && subArr.length === 0)
            ){
                result = []
            }

            return result;
        },
        filteredNodes(){
            /*
                Exclude null entries, bear in mind that node_query DOES NOT contain the search from
                the TextInput
            */
            let node_query = this.node_query.filter(z => z !== null);

            if(node_query || this.outmost_query){

                // Check if the two arrays, path and query, match item-wise
                const arrMatch = (path, query)=> {
                    path = path.map(x => x.toLowerCase().trim() )
                    query= query.map(x => x.toLowerCase().trim() )

                    if (path.length < query.length) return false;

                    for (let i = 0; i < query.length; i++) {
                        if (path[i] !== query[i]) return false;
                    }
                    return true;
                }

                // Check if the last item in a path contains the query from the TextInput
                const strMatch = (path,query) => {
                    return path[path.length-1].toLowerCase().trim().includes(query.toLowerCase().trim());
                }

                let result = this.nodes.filter(node => {
                    const path = node.path.split('>');
                    if (this.outmost_query) {
                        if (node_query.length > 0) {
                            return arrMatch(path, node_query) && strMatch(path, this.outmost_query);
                        } else {
                            return strMatch(path, this.outmost_query);
                        }
                    } else {
                        return node_query.length > 0 ? arrMatch(path, node_query) : true;
                    }
                });

                return result;

            }

            return this.nodes;
        },
    }
};
    </script>
    